import { FormStandard } from "../../../../modules/form/components/FormStandard/FormStandard";
import type { IFormBlockProps } from "./FormBlock.props";

export const FormBlock = (props: IFormBlockProps) => {
  if (!props.fields?.length) {
    return null;
  }

  return <FormStandard {...props} />;
};

FormBlock.displayName = "Block::FormBlock";
